import React, { Component, PropTypes } from 'react';
import OrganizationCard from './OrganizationCard';


export default class OrganizationDetailEditThumbnail extends Component {
  render() {
    return <OrganizationCard isEditMode={true} updateContent={this.props.updateContent} item={this.props.organization} />;
  }
}



// WEBPACK FOOTER //
// ./src/components/OrganizationDetailEditThumbnail.jsx